var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isPaused)?_c('div',{staticClass:"timer-dot-wrapper"},[_c('span',{staticClass:"bullet green"}),_vm._v(" "),_c('p',[_vm._v("Timer is running")])]):_c('div',{staticClass:"timer-dot-wrapper"},[_c('span',{staticClass:"bullet orange"}),_vm._v(" "),_c('p',[_vm._v("Timer is paused")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }